import React, { useState, useEffect, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { applyCouponApi, getCartItem, getCouponDeals } from '../api';
import "../scss/Home.scss";
import "../scss/Deals.scss";
import spinner from "../../images/spinner.gif";

const Header = React.lazy(() => import("../common/Header"));
const Footer = React.lazy(() => import("../common/Footer"));
const DealsComponent = React.lazy(() => import("./DealsComponent"));


export default function Deals(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [couponApplied, setCouponApplied] = useState(false);
    const [cartData, setCartData] = useState(null);
    const [dealsData, setDealsData] = useState([]);
    const [search, setSearch] = useState("");

    useEffect(() => {
        setIsLoading(true);
        async function fetchFunction() {
            const fetchedData = await getCartItem();
            if (fetchedData.data.status) {
                if (fetchedData.data.result) {
                    setCartData(fetchedData.data.result);
                    if (fetchedData.data.result.offer_id) {
                        setCouponApplied(true);
                    }
                }
            }
            setInterval(function () {
                window.$('.dealspopup').addClass('slide');
                if (window.$(".scrolldiv").mCustomScrollbar) {
                    window.$(".scrolldiv").mCustomScrollbar({
                        theme: "rounded-dark",
                    });
                }
            }, 200);
            setIsLoading(false);
        }
        fetchFunction();
    }, []);

    useEffect(() => {
        async function defaultFunc() {
            const fetchDeals = await getCouponDeals();
            if (fetchDeals.status) {
                if (fetchDeals.result) {
                    setDealsData(fetchDeals.result);
                }
            }
        }
        defaultFunc();
    }, [props])

    const applyCoupon = async (coupon) => {
        try {
            props.applyCoupon(coupon);
        } catch (err) {
            setIsLoading(true);
            const fetchedData = await getCartItem();
            if (fetchedData.data.status) {
                if (fetchedData.data.result) {
                    if (coupon) {
                        let couponData = {
                            id: coupon.id,
                            cart_id: fetchedData.data.result.id
                        }
                        try {
                            const applyCouponRes = await applyCouponApi(couponData);
                            if (applyCouponRes.data.status) {
                                setCouponApplied(true);
                                window.createNotification("success", applyCouponRes.data.message);
                            }
                        } catch (error) {
                            window.createNotification("error", error);
                        }
                    } else {
                        window.createNotification("error", "Please select a coupon");
                    }
                } else {
                    window.createNotification("error", "Please add some product in cart to apply coupon");
                }
            }
            setIsLoading(false);
        }
    }

    const closeModal = (e) => {
        try {
            props.closeModal();
            e.preventDefault();
        } catch (err) {

        }
    }

    return (
        <div className="wrapper">
            <Suspense fallback={<div></div>}>
                <Header props={props} />
            </Suspense>
            {
                isLoading
                    ?
                    <div className="loader-default"><img src={spinner} alt="Loading" className="loader-spinner" /></div>
                    :
                    <div className="dealspopup">
                        <div className="dealspopupin">
                            <div className="tophead">
                                <Link to={"/"} onClick={(e) => { closeModal(e); }}>
                                    <div className="closedeals">
                                        <img src="https://api2.nirulas.com/nirulas-api/public/assets/images/close.png" alt="Close" />
                                    </div>
                                </Link>
                                <h2>Deals</h2>
                            </div>

                            <div className="couponform">
                                <div className="form-group">
                                    <input type="text" onKeyUp={(e) => setSearch(e.target.value)} className="form-control" placeholder="Enter Coupon Code" />
                                </div>
                            </div>

                            <div className="offerheading">
                                <h5>Special Offers For You</h5>
                            </div>
                            <div className="alloffers">
                                <div className="offerlist scrolldiv">
                                    <Suspense fallback={<div></div>}>
                                        <DealsComponent search={search} cartData={cartData} couponApplied={couponApplied} data={dealsData} applyCoupon={(d) => applyCoupon(d)} />
                                    </Suspense>
                                    {/* {
                                        dealsData && dealsData.length > 0
                                            ?
                                            dealsData.map(function (couponData, couponKey) {
                                                return (
                                                    <div className="dealsrow" key={couponKey}>
                                                        <div className="dealsoccation">
                                                            <h3>{couponData.title}</h3>
                                                            <p>{couponData.description}</p>
                                                        </div>
                                                        <div className="couponcodebox">
                                                            <div className="couponcode">
                                                                {
                                                                    !couponApplied
                                                                        ?
                                                                        cartData && couponData.min_amount <= cartData.grand_total
                                                                            ?
                                                                            <h4 onClick={(e) => { applyCoupon(couponData); }}>{couponData.code}</h4>
                                                                            :
                                                                            <h4>{couponData.code}</h4>
                                                                        :
                                                                        <h4>{couponData.code}</h4>
                                                                }
                                                            </div>
                                                            {
                                                                !couponApplied
                                                                    ?
                                                                    cartData && couponData.min_amount <= cartData.grand_total
                                                                        ?
                                                                        <Link to={"/"} onClick={(e) => { applyCoupon(couponData); e.preventDefault() }}>Apply</Link>
                                                                        :
                                                                        null
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                cartData && parseInt(cartData.offer_id) === parseInt(couponData.id)
                                                                    ?
                                                                    <p style={{ fontSize: "15px", color: "#00c100" }}>Coupon Applied</p>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            :
                                            <div className="dealsrow">
                                                <div className="dealsoccation">
                                                    <h3>No record found...!</h3>
                                                </div>
                                            </div>
                                    } */}
                                </div>
                            </div>
                        </div>
                    </div>
            }
            <Suspense fallback={<div></div>}>
                <Footer cartCount={cartData} props={props} />
            </Suspense>
        </div>
    )
}